import { z } from "zod";
import { env, loadRuntimeConfig } from "@/config/env";
import { usePreferencesStore } from "@/stores/preferences.store";

/**
 * 应用启动序列：
 * 0. 取运行期配置 /config.json（蓝图 ADR-0102）——**必须最先**，因为下面每一步都读 env；
 *    失败即停：白屏 + 一条说清「配置没挂上」的错误，好过带着 undefined 的地址跑起来。
 * 1. 关闭 Zod JIT，避免触发 CSP `script-src` 对 `new Function` 的拦截
 * 2. 启动 MSW（dev / 且 flag 打开）
 * 3. 应用 localStorage 偏好到 <html>（theme 的 `.dark` class / lang）
 *
 * 鉴权：cookie-only 模式下没有"会话预热"这一步；
 *   - 首次渲染若进受保护路由，`requireAuth` 会自行 GET /api/auth/me 决定放行或跳 /login
 *   - 首次渲染若进 /login，`requireGuest` 同理
 */
export async function bootstrap() {
  await loadRuntimeConfig();
  z.config({ jitless: true });

  if (env.IS_DEV && env.ENABLE_MOCK) {
    const { worker } = await import("@/mocks/browser");
    await worker.start({
      onUnhandledRequest: "bypass",
      serviceWorker: { url: "/mockServiceWorker.js" },
    });
  }

  const prefs = usePreferencesStore.getState();
  const html = document.documentElement;
  const dark =
    prefs.theme === "dark" ||
    (prefs.theme === "system" && window.matchMedia("(prefers-color-scheme: dark)").matches);
  html.classList.toggle("dark", dark);
  html.setAttribute("lang", prefs.language);
}
